import { render } from "./ButtonPrimary.vue?vue&type=template&id=73d99440&scoped=true"
import script from "./ButtonPrimary.vue?vue&type=script&lang=js"
export * from "./ButtonPrimary.vue?vue&type=script&lang=js"

import "./ButtonPrimary.vue?vue&type=style&index=0&id=73d99440&lang=scss&scoped=true"

import exportComponent from "D:\\programmazione\\pronails\\MemsionPrivato\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d99440"]])

export default __exports__